import Vue from 'vue';
import VueI18n from 'vue-i18n';
import enGB, { numberFormats as enGBNumberFormats, dateTimeFormats as enGBDateTimeFormats } from './en-GB';
import enUS, { numberFormats as enUSNumberFormats, dateTimeFormats as enUSDateTimeFormats } from './en-US';
import da, { numberFormats as dkNumberFormats, dateTimeFormats as dkDateTimeFormats } from './da-DK';
import sv, { numberFormats as svNumberFormats, dateTimeFormats as svDateTimeFormats } from './sv-SE';
import no, { numberFormats as noNumberFormats, dateTimeFormats as noDateTimeFormats } from './no-NO';
import fr, { numberFormats as frNumberFormats, dateTimeFormats as frDateTimeFormats } from './fr-FR';
import store from "@/store";
import '@/services/company/locale';

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: store.state.company.COMPANY_LOCALE,
  fallbackLocale: 'en-GB',
  messages: {
    'en-GB': enGB,
    'en-US': enUS,
    'da-DK': da,
    'sv-SE': sv,
    'no-No': no,
    'fr-FR': fr,
  },
  numberFormats: {
    ...enGBNumberFormats,
    ...enUSNumberFormats,
    ...dkNumberFormats,
    ...svNumberFormats,
    ...noNumberFormats,
    ...frNumberFormats,
  },
  dateTimeFormats: {
    ...enGBDateTimeFormats,
    ...enUSDateTimeFormats,
    ...dkDateTimeFormats,
    ...svDateTimeFormats,
    ...noDateTimeFormats,
    ...frDateTimeFormats,
  },
});
